import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

export function normalizeWebsiteSharedUids(
  website_shared_uid: any[],
): string[] {
  return (
    website_shared_uid?.flatMap((item: any) => {
      if (Array.isArray(item)) {
        return item.map((site: any) => (site?.value ? site.value : site));
      }

      if (typeof item === "string") {
        return item.split(",");
      }

      return item?.value ? [item.value] : [item];
    }) || []
  ).filter(Boolean);
}

function normalizeDimensions(dimensions: any[]): string[] {
  return (
    dimensions?.flatMap((item: any) => {
      if (Array.isArray(item)) {
        return item.map((dim: any) =>
          dim?.value ? dim.value : dim?.dimension_name,
        );
      }

      if (typeof item === "string") {
        return item.split(",");
      }

      return [item?.value ? item.value : (item?.dimension_name ?? item)];
    }) || []
  ).filter(Boolean);
}
function appendFirstUidToQuery(
  query: string,
  website_shared_uid: any[],
): string {
  const firstUid = normalizeWebsiteSharedUids(website_shared_uid)?.[0];
  if (firstUid) {
    return `${query}&website_shared_uid=${firstUid}`;
  }
  return query;
}

function getBuiDashboardData(
  oauthTokenHeader: string,
  website_shared_uid: string[],
  QUERY_ID: any,
  dimensions: string[],
  type: string,
  selectedAll: boolean | string,
  start_date?: any,
  end_date?: any,
  periodType?: any,
) {
  let query = "";
  let requestBody: {
    website_shared_uid: string[];
    dimension: string[];
  } = {
    website_shared_uid: [],
    dimension: [],
  };

  if (
    (typeof selectedAll === "boolean" && selectedAll) ||
    (typeof selectedAll === "string" && selectedAll === "true")
  ) {
    if (type === "site" || type === "organization") {
      if (periodType) {
        query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?period_type=${periodType}&type=${type}`;
      } else {
        query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?start_date=${start_date}&end_date=${end_date}&type=${type}`;
      }
      query = appendFirstUidToQuery(query, website_shared_uid);
      requestBody.website_shared_uid =
        normalizeWebsiteSharedUids(website_shared_uid);
    } else {
      const uid = website_shared_uid[0] as any;
      if (periodType) {
        query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?period_type=${periodType}&type=dimension`;
      } else {
        query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?start_date=${start_date}&end_date=${end_date}&type=dimension`;
      }
      query = appendFirstUidToQuery(query, website_shared_uid);
      requestBody.website_shared_uid = [uid?.value ? uid?.value : uid].filter(
        Boolean,
      );
    }
    requestBody.dimension = normalizeDimensions(dimensions);
  } else {
    if (periodType) {
      query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?period_type=${periodType}&type=${type}`;
    } else {
      query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?start_date=${start_date}&end_date=${end_date}&type=${type}`;
    }
    query = appendFirstUidToQuery(query, website_shared_uid);
    requestBody.dimension = normalizeDimensions(dimensions);
    requestBody.website_shared_uid =
      normalizeWebsiteSharedUids(website_shared_uid);
  }
  return fetchWrapper.post(query, requestBody, oauthTokenHeader);
}

function getBuiDashboardData_loadedFromTotal(
  oauthTokenHeader: string,
  website_shared_uid: string[],
  QUERY_ID: any,
  dimensions: string[],
  type: string,
  selectedAll: boolean | string,
  start_date: any,
  end_date: any,
  actionType: any,
) {
  let query = "";
  let requestBody: {
    website_shared_uid: string[];
    dimension: string[];
  } = {
    website_shared_uid: [],
    dimension: [],
  };

  if (
    (typeof selectedAll === "boolean" && selectedAll) ||
    (typeof selectedAll === "string" && selectedAll === "true")
  ) {
    if (type === "site" || type === "organization") {
      query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?start_date=${start_date}&end_date=${end_date}&type=${type}&action_type=${actionType}`;
      query = appendFirstUidToQuery(query, website_shared_uid);
      requestBody.website_shared_uid =
        normalizeWebsiteSharedUids(website_shared_uid);
    } else {
      const uid = website_shared_uid[0] as any;
      query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?start_date=${start_date}&end_date=${end_date}&type=dimension&action_type=${actionType}`;
      query = appendFirstUidToQuery(query, website_shared_uid);
      requestBody.website_shared_uid = [uid?.value ? uid?.value : uid].filter(
        Boolean,
      );
    }
    requestBody.dimension = normalizeDimensions(dimensions);
  } else {
    query = `${apiUrl}//biz_layer_query/run/${QUERY_ID}/?start_date=${start_date}&end_date=${end_date}&type=${type}&action_type=${actionType}`;
    query = appendFirstUidToQuery(query, website_shared_uid);
    requestBody.dimension = normalizeDimensions(dimensions);
    requestBody.website_shared_uid =
      normalizeWebsiteSharedUids(website_shared_uid);
  }
  return fetchWrapper.post(query, requestBody, oauthTokenHeader);
}

function getAllDimesnionsForViewOrganizationalSummary(
  oauthTokenHeader: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/dimensions/`,
    oauthTokenHeader,
  );
}

function getWebsitesInBuiDashboard(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/websites/`,
    oauthTokenHeader,
  );
}

export const buiDashboardService = {
  getBuiDashboardData,
  getAllDimesnionsForViewOrganizationalSummary,
  getBuiDashboardData_loadedFromTotal,
  getWebsitesInBuiDashboard,
};
